import { useEffect, useState } from "react";
import { merchantHomeOpportunitySourceState, type MerchantHomeOpportunitySourceState } from "./workbench/catalogAvailability";
import type { WorkbenchGroup } from "./workbench/contentSchemas";

export const WORKBENCH_CONTENT_TIMEOUT_MS = 15_000;
export const WORKBENCH_CONTENT_TIMEOUT_CODE = "workbench_content_timeout";

export function merchantHomeOpportunitiesState(input: {
  contentFailure?: { code: string } | null;
  contentIsError: boolean;
  contentSkipped: boolean;
  hasCurrentData: boolean;
  overviewReady: boolean;
  firstFetchElapsedMs?: number;
  timeoutMs?: number;
  groups?: readonly WorkbenchGroup[];
}): Omit<MerchantHomeOpportunitySourceState, "state"> & { state: MerchantHomeOpportunitySourceState["state"] | "loading" } {
  if (input.contentFailure) {
    return { state: "error", errorCode: input.contentFailure.code };
  }
  if (input.contentIsError && !input.contentSkipped) {
    return { state: "error" };
  }
  if (input.hasCurrentData) {
    return input.groups ? merchantHomeOpportunitySourceState(input.groups) : { state: "ready" };
  }
  if (input.contentSkipped && input.overviewReady) {
    return { state: "ready" };
  }
  const timeoutMs = input.timeoutMs ?? WORKBENCH_CONTENT_TIMEOUT_MS;
  if (
    !input.contentSkipped &&
    (input.firstFetchElapsedMs ?? 0) >= timeoutMs
  ) {
    return { state: "error", errorCode: WORKBENCH_CONTENT_TIMEOUT_CODE };
  }
  return { state: "loading" };
}

export function useFirstFetchElapsedMs(active: boolean, scopeKey = "") {
  const [tick, setTick] = useState({ key: "", elapsed: 0 });
  useEffect(() => {
    if (!active) return;
    const started = Date.now();
    const timer = window.setInterval(() => {
      setTick({ key: scopeKey, elapsed: Date.now() - started });
    }, 1_000);
    return () => window.clearInterval(timer);
  }, [active, scopeKey]);
  return active && tick.key === scopeKey ? tick.elapsed : 0;
}
